var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckVerified01 = function SvgCheckVerified01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "m6.333 8 1.334 1.333 3-3M5.223 2.546a2.56 2.56 0 0 0 1.453-.602 2.555 2.555 0 0 1 3.314 0c.41.348.918.559 1.454.602a2.555 2.555 0 0 1 2.343 2.343c.043.536.254 1.045.603 1.454.813.955.813 2.36 0 3.314-.349.41-.56.918-.603 1.454a2.555 2.555 0 0 1-2.343 2.343 2.55 2.55 0 0 0-1.454.602 2.555 2.555 0 0 1-3.314 0 2.55 2.55 0 0 0-1.453-.602 2.555 2.555 0 0 1-2.344-2.343 2.56 2.56 0 0 0-.602-1.454 2.555 2.555 0 0 1 0-3.314c.349-.41.56-.918.602-1.454a2.555 2.555 0 0 1 2.344-2.343"
  })));
};
export default SvgCheckVerified01;